import { useClientStore } from '@/features/Clients/store';
import { useFeaturesStore } from '@/features/Features/store';
import { transferQuoteDataToInputStore } from '@/features/Quotes/utils';
import type { VorgabenResponse } from '@/features/Vorgaben/types';
import type { UseLogger } from '@/services/logger/useLogger';

export const transferVorgabenDataToStores = async (
  vorgabenData: VorgabenResponse,
  logger?: UseLogger,
): Promise<void> => {
  logger?.info('loading vorgaben into stores');

  const featuresStore = useFeaturesStore();
  vorgabenData.merkmale.forEach(
    (feature: { identifier: string; value: number }) => {
      try {
        featuresStore.setFeatureByIdentifier(feature.identifier, feature.value);
      } catch {
        /* empty - feature might not exist in current sparte */
      }
    },
  );

  // Result has the same structure as offers. The tariffs shown were calculated with this
  // Versicherungsbeginn, so it must not be moved into the future like for loaded offers.
  transferQuoteDataToInputStore(vorgabenData.eingabedaten, true);

  const clientStore = useClientStore();
  if (vorgabenData.entities && Object.keys(vorgabenData.entities).length > 0) {
    const entities = Object.values(vorgabenData.entities) as any[];
    clientStore.loadClientsFromQuoteEntities(entities, false, false);
  }

  logger?.info('vorgaben loaded successfully into stores');
};
